import Inspector from './inspector';

// Remover caso não seja utilizado
const { InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { variant, margin } = attributes;

  const {
    sideImage,
  } = attributes;

  const ALLOWED_BLOCKS = [
    'app/grid-plans'
  ];

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`plans-details ${variant} ${margin}`}>
        <div className='Container'>
          <InnerBlocks 
            allowedBlocks={ALLOWED_BLOCKS}
            template={[
              [
                'app/grid-plans',
                {
                  plansName: 'directvgo',
                }
              ],
              [
                'app/grid-plans',
                {
                  plansName: 'roku',
                }
              ],
              [
                'app/grid-plans',
                {
                  plansName: 'globoplay',
                }
              ],
              [
                'app/grid-plans',
                {
                  plansName: 'paramount',
                }
              ],
              [
                'app/grid-plans',
                {
                  plansName: 'hbo',
                }
              ],
              [
                'app/grid-plans',
                {
                  plansName: 'premiere',
                }
              ]
            ]}
          />
        </div>
      </section>
    </>
  );
};

export default Edit;